import app from 'app'
import routes from 'routes/landlord'
import reducers from 'reducers/index.landlord'

app({
	appName: 'landlord'
  , routes
  , routesPath: 'routes/landlord' // for HMR
  , reducers
  , reducersPath: 'reducers/index.landlord' // for HMR
})



// WEBPACK FOOTER //
// ./src/landlord.js